import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const DropdownSelectContext = /*#__PURE__*/createContext(undefined);
export const DropdownSelectProvider = ({
  isDropdownSelect,
  children
}) => {
  return /*#__PURE__*/_jsx(DropdownSelectContext.Provider, {
    value: {
      isDropdownSelect
    },
    children: children
  });
};

/**
 * Provides the context for the `DropdownSelect` component.
 * Note: The context is only available when the `DropdownSelect` component is rendered as an ancestor.
 * @returns DropdownSelectContext - The context for the `DropdownSelect` component.
 * @returns DropdownSelectContext.isDropdownSelect - Style overrides to be applied to the `TypeaheadResultsItem` component.
 */
export const useDropdownSelectContext = () => {
  const dropdownSelectContext = useContext(DropdownSelectContext);
  return dropdownSelectContext;
};